module.exports = __webpack_public_path__ + "img/ryzs3.4e010c40.png";